import { Button } from "@mui/material";
import { Order } from "../types";
import OrderAskConfirmTable from "./OrderAskConfirmTable";
import { toOrderCheck } from "../utils/common";

type Props = {
  open: boolean;
  onClose: Function;
  onUpdate: Function;
  selectedOrderList: Order[];
  isUpdateProcessing: boolean;
};

/**
 * 発注確認モーダル
 * @param root0 コンポーネントのプロップス
 * @returns JSX.Element
 */
export default function OrderConfirmDialog({
  open,
  onClose,
  onUpdate,
  selectedOrderList,
  isUpdateProcessing,
}: Props) {
  const ActionButtons = (
    <>
      <Button variant="custom-outlined" onClick={() => onClose()}>
        キャンセル
      </Button>
      <Button variant="contained" onClick={() => onUpdate()} disabled={isUpdateProcessing}>
        発注
      </Button>
    </>
  );
  return (
    <OrderAskConfirmTable
      open={open}
      onClose={onClose}
      orderList={toOrderCheck(selectedOrderList)}
      ActionButtons={ActionButtons}
      title="発注確認"
      content="以下の注文を発注します。よろしいですか？"
    />
  );
}
